import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import TabsContext from './TabsContext.js';
import { TabPanel as TabPanel$2 } from './Tabs.style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "index"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
    index = _ref.index,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(TabsContext),
    selectedIndex = _React$useContext.selectedIndex,
    baseId = _React$useContext.baseId;
  var id = "".concat(baseId, "-tabpanel-").concat(index);
  var tabId = "".concat(baseId, "-tab-").concat(index);
  var selected = index === selectedIndex;
  return /*#__PURE__*/jsx(TabPanel$2, _objectSpread(_objectSpread({}, rest), {}, {
    role: "tabpanel",
    id: id,
    "aria-labelledby": tabId,
    hidden: !selected,
    tabIndex: -1,
    children: children
  }));
};
var TabPanel$1 = TabPanel;

export { TabPanel$1 as default };
//# sourceMappingURL=TabPanel.js.map
